const DIET = 'diet';
const CALORIES = 'calories';

const sortByCalories = (menu) => {
  const getLowestCalories = (product) => {
    const calories = product.portions?.reduce((acc, portion) => {
      if (portion.calories) acc.push(portion.calories);
      return acc;
    }, []);

    return calories?.length ? Math.min(...calories) : Infinity;
  };

  const menuTree = menu.menuTree.map((section) => {
    return {
      ...section,
      children: section.children?.sort((a, b) => {
        const aCalories = getLowestCalories(a);
        const bCalories = getLowestCalories(b);
        return aCalories - bCalories;
      }),
    };
  });

  return {
    ...menu,
    menuTree,
  };
};

const sortByPrice = (menu) => {
  const getLowestPrice = (product) => {
    const prices = product.portions?.reduce((acc, portion) => {
      if (portion.price) acc.push(portion.price);
      return acc;
    }, []);

    return prices?.length ? Math.min(...prices) : Infinity;
  };

  const menuTree = menu.menuTree.map((section) => {
    return {
      ...section,
      children: section.children?.sort((a, b) => {
        const aPrice = getLowestPrice(a);
        const bPrice = getLowestPrice(b);
        return aPrice - bPrice;
      }),
    };
  });

  return {
    ...menu,
    menuTree,
  };
};

const sortBy = (menu, filter) => {
  if (!filter?.length || filter[0].name === 'Relevance') return menu;
  if (filter[0].name === 'Price') return sortByPrice(menu);
  if (filter[0].name === 'Calories') return sortByCalories(menu);
  return menu;
};

const filterByCalories = (product, enabledFilters) => {
  const calories = product.portions?.reduce((acc, portion) => {
    if (portion.calories) acc.push(portion.calories);
    return acc;
  }, []);

  if (!calories?.length) return false;

  return enabledFilters.some((filter) =>
    calories.some((calorie) => calorie >= filter.min && calorie <= filter.max)
  );
};

const filterByDietOpts = (product, enabledFilters) => {
  return enabledFilters.every((filter) => product.keywords?.includes(filter));
};

const filterCategories = (menu, enabledFilters, filterType) => {
  const menuTree = menu.menuTree.map((section) => {
    const children = (section.children || []).filter((product) => {
      if (filterType === DIET) return filterByDietOpts(product, enabledFilters);
      if (filterType === CALORIES) return filterByCalories(product, enabledFilters);
      return product;
    });

    return { ...section, children };
  });

  return { ...menu, menuTree };
};

const caloriesFilter = (menus, filter) => filterCategories(menus, filter, CALORIES);

const dietFilter = (menu, filter) => {
  const NAMES = {
    'Vegan (VG)': 'Vegan',
    'Vegetarian (V)': 'Vegetarian',
    'No Gluten Containing (NGC)': 'Gluten free',
  };
  const enabledFilters = [];
  filter.forEach((f) => {
    if (NAMES[f.name]) enabledFilters.push(NAMES[f.name]);
  });

  return filterCategories(menu, enabledFilters, DIET);
};

const cloneDeep = (fetchedMenus) => JSON.parse(JSON.stringify(fetchedMenus));

const filterIOrderMenus = (menu, filters) => {
  if (!menu) return null;

  const FILTER_NAMES = {
    'Sort by': sortBy,
    Diet: dietFilter,
    Calories: caloriesFilter,
    Others: (currentMenu) => currentMenu,
  };

  let filteredItems = cloneDeep(menu);

  filters.forEach((filter) => {
    filteredItems = FILTER_NAMES[filter.name](filteredItems, filter.values);
  });

  return filteredItems;
};

export default filterIOrderMenus;
